import type { ConsentChoices, GoogleConsentState, OptionalCategoryKey } from './types';

export const createDeniedChoices = (): ConsentChoices => ({
  necessary: true,
  analytics: false,
  marketing: false,
  remarketing: false,
  email: false,
  preferences: false,
});

export const createAcceptedChoices = (categories: OptionalCategoryKey[]): ConsentChoices => {
  const choices = createDeniedChoices();
  categories.forEach((category) => {
    choices[category] = true;
  });
  return choices;
};

export const normalizeChoices = (
  choices: Partial<ConsentChoices> | undefined,
  categories: OptionalCategoryKey[],
): ConsentChoices => {
  const normalized = createDeniedChoices();
  categories.forEach((category) => {
    normalized[category] = choices?.[category] === true;
  });
  return normalized;
};

export const toGoogleConsent = (choices: ConsentChoices): GoogleConsentState => ({
  ad_storage: choices.marketing || choices.remarketing ? 'granted' : 'denied',
  ad_user_data: choices.marketing || choices.email ? 'granted' : 'denied',
  ad_personalization: choices.marketing || choices.remarketing ? 'granted' : 'denied',
  analytics_storage: choices.analytics ? 'granted' : 'denied',
  functionality_storage: choices.preferences ? 'granted' : 'denied',
  personalization_storage: choices.preferences ? 'granted' : 'denied',
  security_storage: 'granted',
});

export const createDefaultGoogleConsent = (): GoogleConsentState => ({
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  analytics_storage: 'denied',
  functionality_storage: 'denied',
  personalization_storage: 'denied',
  security_storage: 'denied',
});
